/* eslint-disable */
import {Button, createStyles, makeStyles, Theme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, DialogProps} from "@material-ui/core";
import styles from "./OnLeaveDialog.module.css";
import React from "react";
import ErrorIcon from '@material-ui/icons/Error';

interface OnLeaveDialogProps {
    openDialog: boolean;
    handleCloseDialog: () => void;
    handleCancel: () => void;
    handleConfirm: () => void;
}

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        dialogTitle: {
            padding: "16px 24px 16px 10px"
       },
        dialogContent: {
            marginLeft: "30px",
       },
        dialogActions: {
            marginTop: "15px",
            marginBottom: "10px",
            marginRight: "10px",
       }
   }),
);

function OnLeaveDialog({
    openDialog,
    handleCloseDialog,
    handleCancel,
    handleConfirm
}: OnLeaveDialogProps) {

    const classes = useStyles();
    const handleClose:DialogProps["onClose"] = (evt,reson) => {
        if (reson === 'backdropClick') {
            return
        }
        handleCloseDialog()
    }
    return (
        <Dialog
                disableEscapeKeyDown
                fullWidth={false}
                maxWidth="md"
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className={styles.dialogTitle}>
                    <ErrorIcon fontSize="large" color="secondary" style={{color: "var(--red)"}} />
                    <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">ページを遷移しますか？</DialogTitle>
                </div>
                <DialogContent className={classes.dialogContent}>
                    <DialogContentText id="alert-dialog-description">
                        ページを遷移すると、変更内容は失われます。
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button size="medium" variant="contained" type="submit" color="secondary" style={{backgroundColor: "var(--red)"}} onClick={handleConfirm} autoFocus>
                        ページ遷移
                    </Button>
                    <Button size="medium" variant="outlined" type="submit" color="secondary" onClick={handleCancel}>
                        キャンセル
                    </Button>
                </DialogActions>
            </Dialog>
    );
}

export default OnLeaveDialog;
